<template>
  <v-form
    ref="form"
    lazy-validation
    v-if="formData && !sent">
    <v-layout>
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs12 pa-3>
            <h2 class="pb-3">{{panelTitle}}</h2>
          </v-flex>
          <v-flex xs4 px-3>
            <v-select
              :dark="colour !== 'white'"
              :light="colour === 'white'"
              v-model="formData.title"
              :items="titleOptions"
              :error-messages="titleErrors"
              required
              @input="$v.formData.title.$touch()"
              @blur="$v.formData.title.$touch()"
              outline
              label="Title"/>
          </v-flex>
          <v-flex xs8 px-3>
            <v-text-field
              :dark="colour !== 'white'"
              :light="colour === 'white'"
              v-model="formData.name"
              outline
              :error-messages="nameErrors"
              required
              @input="$v.formData.name.$touch()"
              @blur="$v.formData.name.$touch()"
              type="text"
              label="Name*" />
          </v-flex>
          <v-flex xs12 px-3>
            <v-text-field
              :dark="colour !== 'white'"
              :light="colour === 'white'"
              v-model="formData.email"
              outline
              :error-messages="emailErrors"
              required
              @input="$v.formData.email.$touch()"
              @blur="$v.formData.email.$touch()"
              type="email"
              label="Email*" />
          </v-flex>
          <v-flex xs12 px-3>
            <v-text-field
              :dark="colour !== 'white'"
              :light="colour === 'white'"
              v-model="formData.telephone"
              outline
              type="text"
              label="Telephone" />
          </v-flex>
          <v-flex xs12 px-3>
            <v-textarea
              :dark="colour !== 'white'"
              :light="colour === 'white'"
              v-model="formData.message"
              outline
              label="Message"
              auto-grow/>
          </v-flex>
          <v-flex xs12 pa-3 class="text-xs-center">
            <v-btn
              :loading="sending"
              :disabled="sending"
              outline
              large
              :dark="colour !== 'white'"
              :light="colour === 'white'"
              @click="send"
            >Send
              <template v-slot:loader>
                <span class="custom-loader">
                  <icon iconName="cached" :class="[ 'icon--white']" />
                </span>
              </template>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-snackbar
      v-model="toast"
      color="error"
      bottom="bottom"
      :timeout="timeout"
    >
      {{ snackbarText }}
      <v-btn
        light
        flat
        @click="toast = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-form>

  <v-layout v-else>
    <v-flex xs12>
      <div class="title text-xs-center pt-3 pb-5">
      Thank you for your enquiry.
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { postDataObj } from '../../api/api'
import icon from '../icons/Icon'

export default {
  name: 'car-enquiry-form',

  components: {icon},

  mixins: [validationMixin],

  props: {
    colour: {
      type: String
    },
    params: {}
  },

  validations: {
    formData: {
      title: { required },
      name: { required },
      email: { required, email }
    }
  },

  computed: {
    titleErrors () {
      const errors = []
      if (!this.$v.formData.title.$dirty) return errors
      !this.$v.formData.title.required && errors.push('Please select your title.')
      return errors
    },
    nameErrors () {
      const errors = []
      if (!this.$v.formData.name.$dirty) return errors
      !this.$v.formData.name.required && errors.push('Please enter your name.')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.formData.email.$dirty) return errors
      !this.$v.formData.email.email && errors.push('Must be valid e-mail')
      !this.$v.formData.email.required && errors.push('Please enter your email.')
      return errors
    }
  },

  data() {
    return {
      toast: false,
      snackbarText: 'Please complete the form',
      timeout: 5000,
      formData: {
        title: '',
        name: '',
        email: '',
        telephone: '',
        message: '',
        car: false,
        type: 'inventory enquiry'
      },
      titleOptions: [
        'Mr', 'Mrs', 'Ms', 'Miss', 'Dr', 'Prof', 'Rev'
      ],
      sent: false,
      sending: false,
      panelTitle: 'Enquiry About This Vehicle'
    }
  },

  methods: {
    send () {
      this.$v.$touch()

      if (!this.$v.$error) {
        this.sending = true
        this.formData.car = this.$route.params.vara
        let formData = JSON.parse(JSON.stringify(this.formData))

        postDataObj('contacts/sendEnquiry', formData).then(results => {
          if (results) {
            this.sent = true
            this.sending = false
          }
        })
      } else {
        this.toast = true
      }
    }
  },
  created () {
    if (this.params.panelTitle) {
      this.panelTitle = this.params.panelTitle
    }
  },
  destroyed () {
    this.sent = false
    this.sending = false
  }
}
</script>
